import { iconMapper } from "./Icons.mapper";
import { IconProps } from "./Icons.types";
import { isString, isUndefined } from "ramda-adjunct";
import { SvgIcon } from "./SvgIcon";
import { IconRT } from "./Icon";
import { isReactComponent } from "../_utils/is-react-component.func";



export const IconTalTech: React.FC<any> = (props: IconProps & {onClick?: any}) => {
  const { kind, ...rest  } = props;
  const builder = iconMapper.get(kind);
  if (isUndefined(builder)) {
    return <>{kind} icon not found</>;
  }
  if(isString(builder)) {

    const name = (builder as any);
    const result = <div className={"ebd-icon"}>
      {<IconRT kind={kind} color={"blue"} {...rest}/>}
    </div>
    return result;
  }
  const IconComponent = (builder as any);
  const result = <div className={"ebd-icon"}>
    <IconRT kind={kind} color={"blue"} {...rest}/>
  </div>
  return result;
};
